import { API } from '@thuas/pd-schemas';
import api from 'helpers/api';
import { prepareForBackend, toArrayOfIdObject } from 'helpers/objects';

export type ISection = API['Section']['read'];
export type ISectionCreate = Omit<API['Section']['create'], 'files'> & {
  files?: [id: number];
  filesAdd?: { id: number }[];
};
export type ISectionUpdate = API['Section']['update'] & {
  filesOverwrite?: { id: number }[];
};

function prepareForCreate(section: ISection): ISectionCreate {
  const prepared = prepareForBackend(section, ['files']) as ISectionCreate;
  prepared.page = section.page?.id ?? 0;
  return prepared;
}

function prepareForUpdate(section: ISection): ISectionUpdate {
  const updated = prepareForBackend(section, ['id']) as ISectionUpdate;
  updated.filesOverwrite = toArrayOfIdObject(section.files);

  return updated;
}

export const postSection = async (data: ISection) => {
  try {
    const response: any = await api.post('Section', {
      ...prepareForCreate(data),
    });
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const patchSection = async (data: ISection) => {
  try {
    const response = await api.patch(
      'Section/' + data.id,
      prepareForUpdate(data),
    );
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const deleteSection = async (id: number) => {
  try {
    const response: any = await api.delete('Section/' + id);
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};
